<template>
  <v-app id="menu">
    <v-img
      v-if="
        !$auth.isAuthenticated() &&
          !['inviteCadastro', 'cadastro'].includes($route.name)
      "
      height="812"
      :src="require(`./assets/bgBolden.svg`)"
    >
      <v-content>
        <div>
          <router-view />
        </div>
      </v-content>
    </v-img>

    <v-layout
      v-if="['termosdeuso'].includes($route.name)"
      class="d-flex justify-center align-center"
    >
      <div>
        <router-view />
      </div>
    </v-layout>

    <v-layout v-if="($auth.isAuthenticated() && profile.disabled)">
      <div
        class="suspended"
      >
        <NotFound />
      </div>
    </v-layout>

    <v-layout
      v-if="
        (($auth.isAuthenticated() &&
          !['termosdeuso'].includes(
            $route.name
          )) || (!$auth.isAuthenticated() && ['inviteCadastro', 'cadastro'].includes(
          $route.name
        ))) && !profile.disabled
      "
    >
      <Header />
      <v-content style="margin-top: 26px">
        <div>
          <WelcomeCard
            v-if="$store.state.isNewAccount && $store.getters.isSeller && $store.getters.getCustomer && !$store.getters.getCustomer.onlyCatalogue"
            title="Bem vindo!"
          >
            <template #default>
              <h5 class="caption">
                Estamos sincronizando seu App para que você possa acompanhar
                suas campanhas e agenda.
              </h5>
              <h5 class="caption my-2">
                Dentro de <span class="font-weight-bold">até 24h</span> ele
                estará pronto para uso!
              </h5>
            </template>
          </WelcomeCard>
          <router-view />
        </div>
      </v-content>
      <Footer v-if="$auth.isAuthenticated() && !['inviteCadastro', 'cadastro'].includes($route.name)" />
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      class="snackBar"
      :color="snackColor"
      :top="true"
      :multi-line="true"
      :timeout="timeout"
      :style="`color: ${snackTextColor}; ${snackStyle}`"
    >
      <v-icon
        v-if="snackIcon"
        medium
        :color="snackTextColor"
        class="mr-3"
      >
        {{ snackIcon }}
      </v-icon>
      {{ snackText }}
      <v-btn
        v-if="snackButton"
        class="snackbar-btn"
        width="675px"
        outline
        :style="`color: ${snackTextColor}`"
        @click="snackbar = false"
      >
        Ok
      </v-btn>
    </v-snackbar>
    <v-fab-transition>
      <v-btn
        v-if="toTopButtonVisible"
        color="#140C22"
        dark
        fixed
        bottom
        right
        fab
        class="top-redirect-btn"
        @click="redirectToTop"
      >
        <v-icon
          medium
          color="#FFF"
        >
          mdi-arrow-up
        </v-icon>
      </v-btn>
    </v-fab-transition>
  </v-app>
</template>

<script>
import '@/resources/clipboard';
import LogRocket from 'logrocket';
import auth from '@/auth.js';
import { CustomersBySellerId, isNewAccount } from '@/apollo';
import NotFound from '@/views/NotFound.vue';
import { APIService } from './resources/campanha.js';
import { EventBus } from './event-bus.js';

export default {
  name: 'App',
  components: {
    NotFound,
  },
  data() {
    return {
      timeout: 2000,
      snackbar: false,
      snackText: '',
      snackColor: '',
      snackTextColor: '',
      multiline: false,
      profile: null,
      snackButton: true,
      snackIcon: null,
      snackClass: {},
      toTopButtonVisible: false,
    };
  },
  computed: {
    authorized() {
      return this.$auth.isAuthenticated();
    },
    customers() {
      return this.$store.state.customers;
    },
    snackStyle() {
      let style = '';
      Object.entries(this.snackClass).forEach((property) => {
        style += `${property[0]}: ${property[1]};`;
      });
      if (!style.includes('justify-content')) {
        style += 'justify-content: space-between;';
      }
      return style;
    },
  },
  watch: {
    '$store.state.profile': async function () {
      this.$store.commit('SET_NEW_ACCOUNT', false);
      if (this.$store.state.profile.id) {
        this.validateTermsOfUse();
      }
      this.$store.commit('SET_NEW_ACCOUNT', await this.isNewAccount());
    },
    async $route() {
      if (this.$store.state.profile) {
        this.validateTermsOfUse();
      }
    },
    async sellerId() {
      await this.setStore();
    },
    async authorized() {
      if (!this.$auth.isAuthenticated()) {
        this.$store.commit('SET_CUSTOMERS', []);
      }
    },
  },
  created() {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  },
  async mounted() {
    window.document.body.onscroll = () => {
      this.toTopButtonVisible = window.scrollY > window.outerHeight;
    };

    EventBus.$on('activeSnackBar', (snackBar) => {
      this.snackbar = snackBar.value;
      this.snackText = snackBar.text;
      this.snackButton = snackBar.hasOwnProperty('button') ? snackBar.button : true;
      this.snackIcon = snackBar.icon ? snackBar.icon : null;
      this.snackClass = snackBar.class ? snackBar.class : {};
      this.multiline = snackBar.multiline ? snackBar.multiline : false;
      this.snackColor = snackBar.color ? snackBar.color : '#FFADDE';
      this.snackTextColor = snackBar.textColor ? snackBar.textColor : '#FFFFFF';
      this.timeout = snackBar.timeout ? snackBar.timeout : 4000;
    });

    this.$auth.checkVuex();
    if (this.$auth.isAuthenticated()) {
      await this.setStore();
      this.$ga.set('userId', this.$auth.user.sub);
      LogRocket.identify(this.$auth.user.sub, {
        name: this.$auth.user.nickname,
        email: this.$auth.user.name,
      });
      this.$store.dispatch('carregarPerfil', { user: this.$auth.user });
      this.$store.dispatch('carregarListaContatos', {
        user: this.$auth.user,
        force: true,
      });
      this.$store.commit('SET_NEW_ACCOUNT', await this.isNewAccount());
      // this.$store.dispatch("carregarAgendaMarca", this.$auth.user);
    }

    this.profile = this.$store.getters.getProfile;
  },
  methods: {
    redirectToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    validateTermsOfUse() {
      const seller = this.$store.state.profile;
      const impersonated = this.$auth.user && this.$auth.user.secondPicture;
      if (seller && (!seller.termsOfUse || !(seller.termsOfUse.termVersion === 'v1.1')) && !impersonated) {
        this.$router.push('/termosdeuso');
      }
    },
    async setStore() {
      const res = await this.$apollo.query({
        query: CustomersBySellerId,
        variables: {
          sellerId: this.$auth.user.sub,
        },
        fetchPolicy: 'no-cache',
      });
      const customers = res.data.customersBySellerId;
      this.$store.commit('SET_CUSTOMERS', customers);
      if (!customers) {
        this.$store.commit('HAS_MULTITENANT', false);
        return;
      }
      if (!customers || customers.length == 0) return;
      const customer = customers[0];

      const seller = customer.stores
        .map((s) => s.sellers)
        .reduce((a, b) => a.concat(b), [])
        .find((s) => s._id === this.$auth.user.sub) || {};
      this.$store.commit('SET_PERFIL', seller);

      if (
        customers.length > 1
        || customer.stores.length > 1
        || seller.manager
      ) {
        this.$store.commit('HAS_MULTITENANT', true);
        const customerIds = customers.map((customer) => customer.id);
      } else if (customers.length == 1) {
        const customer = customers[0];
        if (customer.stores.length > 1) {
          this.$store.commit('HAS_MULTITENANT', true);
        }
      }
    },
    async isNewAccount() {
      const result = await this.$apollo.query({
        query: isNewAccount,
        variables: {
          customerId: this.$store.getters.getCustomer.id,
          sellerId: this.$auth.user.sub,
        },
      });
      return result.data.isNewAccount;
    },
  },
};
</script>

<style>
#app {
  font-family: "Montserrat", "Roboto", Arial, sans-serif;
}

input:autofill,
input:autofill:focus,
input:autofill:hover,
select:autofill,
select:autofill:focus,
select:autofill:hover,
textarea:autofill,
textarea:autofill:focus,
textarea:autofill:hover {
  -webkit-text-fill-color: black !important;
}
.v-messages__message {
  font-family: 'Nunito sans', sans-serif;
}
.v-snack {
  font-family: 'Nunito sans', sans-serif;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: black !important;
}
.application {
font-family: 'Nunito sans'
}
</style>

<style lang="scss">
@import "@/styles/material-dashboard/_mixins.scss";
@import "@/styles/material-dashboard/_variables.scss";
@import "@/styles/material-dashboard/_cards.scss";
@font-face{
    font-family:"neue-metana";
    src:url("assets/NEUE METANA-VF.TTF")
}
</style>
<style scoped>
::v-deep .snackBar {
  caret-color: #140C22 !important;
  text-align: left !important;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.1) !important;
}

::v-deep .v-snack__wrapper {
  height: 100%;
  justify-content: inherit;
}

::v-deep .v-snack__content {
  justify-content: inherit;
}

.snackbar-btn {
  border-radius: 7.08982px;
  caret-color: #140C22 !important;
  min-width: 83px !important;
}

.suspended {
  width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.top-redirect-btn {
  margin: 0px 5px 90px 0;
}
</style>
